

import type { FoodItem } from '../types';

export const menuArray: FoodItem[] = [

  {

    id: 0,

    name: "Jollof Rice",

    ingredients: ["rice", "turkey", "salad"],

    price: 2000,

    image: "IMG_E6750-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 1,

    name: "Jollof Rice (Standard)",

    ingredients: ["Rice", "Turkey"],

    price: 2000,

    image: "IMG_E6751-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 2,

    name: "Spaghetti",

    ingredients: ["Spaghetti", "Chicken"],

    price: 1500,

    image: "IMG_E6755-removebg-preview.png",

    category: 'Sides'

  },

  {

    id: 3,

    name: "Jollof Spaghetti",

    ingredients: ["spaghetti", "chicken"],

    price: 2000,

    image: "IMG_E6756-removebg-preview.png",

    category: 'Sides'

  },

  {

    id: 4,

    name: "Semo and Efo Riro",

    ingredients: ["Semo", "efo", "meat", "sliced ponmo"],

    price: 1700,

    image: "IMG_E6757-removebg-preview.png",

    category: 'Swallow'

  },

  {

    id: 5,

    name: "White Rice",

    ingredients: ["rice", "chicken"],

    price: 1700,

    image: "IMG_E6758-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 6,

    name: "Ofada Rice",

    ingredients: ["rice", "egg", "stew", "fried plantain", "ponmo", "fish"],

    price: 2000,

    image: "IMG_E6759-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 7,

    name: "Fried Rice",

    ingredients: ["rice", "chicken", "salad"],

    price: 2000,

    image: "IMG_E6760-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 8,

    name: "Concoction Rice",

    ingredients: ["rice", "egg", "fish", "sliced plantain"],

    price: 1000,

    image: "IMG_E6762-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 9,

    name: "Egusi Soup",

    ingredients: ["vegetable", "meat", "ponmo", "fish garri"],

    price: 6000,

    image: "IMG_E6764-removebg-preview.png",

    category: 'Swallow'

  },

  {

    id: 10,

    name: "Ogbono",

    ingredients: ["ogbono", "vegetable", "garri", "ponmo and meat"],

    price: 7000,

    image: "IMG_E6766-removebg-preview.png",

    category: 'Swallow'

  },

  {

    id: 11,

    name: "Croaker Fish",

    ingredients: ["fish", "potato"],

    price: 4000,

    image: "IMG_E6773-removebg-preview.png",

    category: 'Sides'

  },

  {

    id: 12,

    name: "Egusi and Pounded Yam",

    ingredients: ["Efo riro", "fish", "pounded yam"],

    price: 2000,

    image: "IMG_E7014-removebg-preview.png",

    category: 'Swallow'

  },

  {

    id: 13,

    name: "Efo Riro and Yam",

    ingredients: ["Efo", "fish", "yam"],

    price: 2000,

    image: "IMG_E7015-removebg-preview.png",

    category: 'Sides'

  },

  {

    id: 14,

    name: "Moi Moi",

    ingredients: ["Beans", "Fish"],

    price: 700,

    image: "IMG_E7021-removebg-preview.png",

    category: 'Sides'

  },

  {

    id: 15,

    name: "Beans",

    ingredients: ["beans", "fish", "yam"],

    price: 1500,

    image: "IMG_E7027-removebg-preview.png",

    category: 'Sides'

  },

  {

    id: 16,

    name: "Jollof Rice Special",

    ingredients: ["rice", "plantain", "fish"],

    price: 2000,

    image: "IMG_E7028-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 17,

    name: "Jollof Rice (Classic)",

    ingredients: ["rice", "meat", "plantain"],

    price: 2000,

    image: "IMG_E7029-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 18,

    name: "White Rice (Deluxe)",

    ingredients: ["rice", "plantain", "efo riro", "titus fish"],

    price: 1700,

    image: "IMG_E7031-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 19,

    name: "Jollof Rice (Fish)",

    ingredients: ["rice", "plantain", "croaker fish"],

    price: 2000,

    image: "IMG_E7032-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 20,

    name: "Stick Meat",

    ingredients: ["meat"],

    price: 9000,

    image: "IMG_E7034-removebg-preview.png",

    category: 'Sides'

  },

  {

    id: 21,

    name: "White Rice & Peppersoup",

    ingredients: ["rice", "meat", "vegetable", "pepper soup"],

    price: 2000,

    image: "IMG_E7036-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 22,

    name: "Ogbono Special",

    ingredients: ["ogbono", "semo", "turkey meat ponmo"],

    price: 1700,

    image: "IMG_E7038-removebg-preview.png",

    category: 'Swallow'

  },

  {

    id: 23,

    name: "White Rice & Turkey",

    ingredients: ["turkey", "rice"],

    price: 1700,

    image: "IMG_E7040-removebg-preview.png",

    category: 'Rice'

  },

  {

    id: 24,

    name: "Yam & Chicken",

    ingredients: ["yam", "chicken", "can soft drink"],

    price: 4500,

    image: "IMG_E7046-removebg-preview.png",

    category: 'Sides'

  },

  {

    id: 25,

    name: "Fruit Platter",

    ingredients: ["apple", "water melon"],

    price: 500,

    image: "IMG_E7048-removebg-preview.png",

    category: 'Drinks'

  },

  {

    id: 26,

    name: "Fried Spaghetti",

    ingredients: ["spaghetti", "plantain"],

    price: 1000,

    image: "IMG_E7049-removebg-preview.png",

    category: 'Sides'

  },

  {

    id: 27,

    name: "Ofada Rice (Standard)",

    ingredients: ["rice", "egg", "beef"],

    price: 2000,

    image: "IMG_E7013.JPG",

    category: 'Rice'

  }

]; 